import { render, staticRenderFns } from "./FolderAddModal.vue?vue&type=template&id=29932767&"
import script from "./FolderAddModal.vue?vue&type=script&lang=js&"
export * from "./FolderAddModal.vue?vue&type=script&lang=js&"
import style0 from "./FolderAddModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports